/*  MUI  */
import { TableCell, TableRow } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ManagedTableEmptyRows = ({
    colSpan,
    emptyRowsMessage,
    searchEnabled,
    searchText
}) => {
    const { t } = useTranslation();

    return (
        <TableRow
            variant="noHover"
            sx={{ backgroundColor: 'table.emptyRowsBackground' }}
        >
            <TableCell
                colSpan={colSpan}
                sx={{ fontWeight: 600, padding: '75px', textAlign: 'center' }}
            >
                {/* If we're actively searching the table */}
                {searchEnabled && searchText !== ''
                    ? t('ManagedTable.noSearchResults')
                    : emptyRowsMessage || t('ManagedTable.noResults')}
            </TableCell>
        </TableRow>
    );
};
